import { CreateAccountRouter } from './routes/create-account.routes';
import './Create-account.scss';


export const CreateAccount = () => {
  return <CreateAccountRouter />;
};
